import {useState} from "react";
import CommonOvcodeUnilabService from "../services/api/common_ovcode_unilab";

const useCommonOvcodeUnilab = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [distinct_country, setDistinctCountry] = useState(null);
    const [distinct_region, setDistinctRegion] = useState(null);

    const [isLoadingGetDistinctProvince, setIsLoadingGetDistinctProvince] = useState(false)
    const [distinctProvinceData, setDistinctProvinceData] = useState([])
    const [distinctProvinceErr, setDistinctProvinceErr] = useState(null)

    const [isLoadingGetDistinctProducts, setIsLoadingGetDistinctProducts] = useState(false)
    const [distinctProductsData, setDistinctProductsData] = useState([])
    const [distinctProductsErr, setDistinctProductsErr] = useState(null)

    const getDistinctCountry = () => {
        setLoading(true);
        CommonOvcodeUnilabService.getDistinctCountry().then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            setDistinctCountry(res.data.data);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getDistinctRegion = (country) => {
        setLoading(true);
        CommonOvcodeUnilabService.getDistinctRegion(country).then((res)=>{
            setLoading(false);
            if (!res.data.success) setError(res.data.error);
            setDistinctRegion(res.data.data);
        }).catch((error)=>{
            setLoading(false);
            setError(error);
        });
    }

    const getDistinctProvince = (country, region) => {
        setIsLoadingGetDistinctProvince(true);
        CommonOvcodeUnilabService.getDistinctProvince(country, region).then((res)=>{
            console.log("res getDistinctProvince xx ", res.data);
            
            setIsLoadingGetDistinctProvince(false);
            if (!res.data.success) {
                setDistinctProvinceErr(res.data.error)
            } else {
                setDistinctProvinceData(res.data.data);
            };
        }).catch((error)=>{
            setIsLoadingGetDistinctProvince(false);
            setDistinctProvinceErr(error);
        });
    }

    const getDistinctProducts = () => {
        setIsLoadingGetDistinctProducts(true);
        CommonOvcodeUnilabService.getDistinctProducts().then((res)=>{
            setIsLoadingGetDistinctProducts(false);
            if (!res.data.success) {
                setDistinctProductsErr(res.data.error)
            } else {
                setDistinctProductsData(res.data.data);
            };
        }).catch((error)=>{
            setIsLoadingGetDistinctProducts(false);
            setDistinctProductsErr(error);
        });
    }

    return { 
        loading, error,
        distinct_country, getDistinctCountry,
        distinct_region, getDistinctRegion,
        getDistinctProvince, isLoadingGetDistinctProvince, distinctProvinceData, distinctProvinceErr,
        getDistinctProducts, isLoadingGetDistinctProducts, distinctProductsData, distinctProductsErr
    }

}

export default useCommonOvcodeUnilab;
